export default "__VITE_ASSET__CeI8mrIc__"